import { getNotificationByIdSuperAdmin } from '@/services/api/requests/notifications';
import { useQuery } from '@tanstack/react-query';

const useGetNotificationByIdSuperAdmin = (id?: string) => {
  const { isLoading, data, isError, isSuccess } = useQuery({
    queryKey: ['notification', id],
    queryFn: async () => {
      if (!id) {
        throw new Error('Notification ID is required');
      }

      const notification = await getNotificationByIdSuperAdmin(id);
      return notification;
    },
  });

  return {
    isLoading,
    data,
    isError,
    isSuccess,
  };
};

export default useGetNotificationByIdSuperAdmin;
